import { render, staticRenderFns } from "./OldVersionBanner.vue?vue&type=template&id=166357ae&scoped=true"
import script from "./OldVersionBanner.vue?vue&type=script&lang=js"
export * from "./OldVersionBanner.vue?vue&type=script&lang=js"
import style0 from "./OldVersionBanner.vue?vue&type=style&index=0&id=166357ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166357ae",
  null
  
)

export default component.exports